// src/components/PubliekeKaart.js
// Eén publieke voorvertoning als kaart (in de stijl van de stapkaarten van de app): de afbeelding, de
// titel en de eerste regel, en de hele kaart een link naar de voorvertoning. Op het overzicht
// (/alle-doorloopjes) en onder elke voorvertoning bij zijn buren. De stijl staat in PubliekeDoorloopjes.css.
import React from 'react';
import { Link } from 'react-router-dom';

import { voorvertoningPad } from '../utils/publiekOverzicht';

function PubliekeKaart({ item }) {
  return (
    <Link to={voorvertoningPad(item.slug, item.type)} className="publiek-kaart step-card">
      <div className="step-card-image-container">
        {item.image ? (
          <>
            <img src={item.image.url} alt="" aria-hidden="true" loading="lazy" className="step-card-image-background" />
            <img src={item.image.url} alt={item.title} loading="lazy" className="step-card-image-foreground" />
          </>
        ) : (
          <div className="step-card-image-placeholder"></div>
        )}
      </div>
      <div className="step-card-content">
        <h3>{item.title}</h3>
        {item.first_line && <p>{item.first_line}</p>}
      </div>
    </Link>
  );
}

export default PubliekeKaart;
